/* SCROLL UP ON ANCHOR CLICK */ $(document).on("click", "[data-scroll-to-id]", function(event) {
    event.preventDefault();
    var scrollToElementID = $(this).attr("data-scroll-to-id");
    var offsetTop = $("body").find('[id="' + scrollToElementID + '"]').offset().top - 60;
    $("html, body").animate({
        scrollTop: offsetTop
    }, 500);
});
/* CHECK IF TOUCH DEVICE */ window.isTouchDevice = function() {
    var prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
    var mq = function mq(query) {
        return window.matchMedia(query).matches;
    };
    if ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch) return true;
    var query = [
        "(",
        prefixes.join("touch-enabled),("),
        "heartz",
        ")"
    ].join("");
    return mq(query);
};
if (isTouchDevice()) $("body").addClass("is_touch_device");
/* COPY TO CLIPBOARD */ $("body").on("click", "[data-copy]", function() {
    "use strict";
    var valueToCopy = $(this).attr("data-copy");
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(valueToCopy).select();
    document.execCommand("copy");
    $temp.remove();
    var container = $(this);
    container.addClass("copied").text("Copied");
    setTimeout(function() {
        container.removeClass("copied").html("");
    }, 500);
});
/* FORMAT THOUSANDS */ function addCommas(nStr) {
    nStr += "";
    x = nStr.split(".");
    x1 = x[0];
    x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while(rgx.test(x1))x1 = x1.replace(rgx, "$1,$2");
    return x1 + x2;
}
/* DROPDOWN */ $("body").on("click", '[data-action="dropdown_toggle"]', function() {
    $("body").find('[data-action="dropdown_menu"]').not($(this).next('[data-action="dropdown_menu"]')).prev('[data-action="dropdown_toggle"]').removeClass("open");
    if ($(this).hasClass("open")) $(this).removeClass("open");
    else $(this).addClass("open");
});
$("body").on("click", function(event) {
    if ($(event.target).attr("data-action") !== "dropdown_toggle") $("body").find('[data-action="dropdown_toggle"]').removeClass("open");
});
window.closeAllDropdownMenus = function() {
    $("body").find('[data-action="dropdown_toggle"]').removeClass("open");
};
/* MOBILE MENU - BURGER */ $("body").on("click", '[data-action="mobile_menu_toggle"]', function() {
    if ($(this).hasClass("open")) {
        $(this).removeClass("open");
        $("body").find(".header_nav_center:not(.tablet_only)").removeClass("mobile_menu_open");
        $("body").css("overflow", "visible");
    } else {
        $(this).addClass("open");
        $("body").find(".header_nav_center:not(.tablet_only)").addClass("mobile_menu_open");
        $("body").css("overflow", "hidden");
    }
});
/* COLLECT GET VARIABLES FROM CURRENT URL */ function currentGetVariables() {
    var $_GET = {};
    document.location.search.replace(/\??(?:([^=]+)=([^&]*)&?)/g, function() {
        function decode(s) {
            return decodeURIComponent(s.split("+").join(" "));
        }
        $_GET[decode(arguments[1])] = decode(arguments[2]);
    });
    return $_GET;
}
/* validate email */ function isValidEmailAddress(emailAddress) {
    var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
    return pattern.test(emailAddress);
}
/* COUNTDOWN */ window.initAllCountdowns = function() {
    var x3;
    $("body").find("[data-countdown]").each(function(i) {
        var that = $(this);
        // timestamp must be in milliseconds
        var toTimestamp = parseInt($(this).attr("data-countdown"));
        // Set the date we're counting down to
        var countDownDate = new Date(toTimestamp).getTime();
        // Update the count down every 1 second
        x3 = setInterval(function() {
            // Get today's date and time
            var now = new Date().getTime();
            // Find the distance between now and the count down date
            var distance = countDownDate - now;
            // Time calculations for days, hours, minutes and seconds
            var days = Math.max(Math.floor(distance / 86400000), 0);
            var hours = Math.max(Math.floor(distance % 86400000 / 3600000), 0);
            var minutes = Math.max(Math.floor(distance % 3600000 / 60000), 0);
            var seconds = Math.max(Math.floor(distance % 60000 / 1000), 0);
            // display results
            that.find(".days").html(days);
            that.find(".hours").html(hours);
            that.find(".minutes").html(minutes);
            that.find(".seconds").html(seconds);
        }, 1000);
    });
};
initAllCountdowns();
/* GENERAL ERROR INFO SUCCESS MESSAGE */ function generalInfo(showHide, type, message) {
    "use strict";
    var alertsContainer;
    // if .alerts exists already, use existing one
    if ($("body").find(".alerts").length) alertsContainer = $("body").find(".alerts");
    else {
        // else shout
        alert(message);
        return false;
    }
    if (showHide == "hide") alertsContainer.find(".alert:not(.static)").remove();
    else if (showHide && type && message) alertsContainer.html('<p class="alert ' + type + '">' + message + "</p>");
}
/* play video */ $("body").on("click", ".play", function() {
    $("body").find(".play").remove();
    $("body").find("video").addClass("is_now_playing");
    $("body").find("video").trigger("play");
    $("body").find("video").attr("controls", "controls");
});
/* submit newsletter signup */ $("body").on("submit", 'form[name="newsletter"]', function(e) {
    "use strict";
    e.preventDefault();
    var button = $(this).find('button[type="submit"]');
    var emailInput = $("body").find('[name="newsletter[email]"]');
    var error = false;
    if (!emailInput.val() || !isValidEmailAddress(emailInput.val())) {
        error = true;
        emailInput.addClass("error");
    } else emailInput.removeClass("error");
    if (error === true) {
        generalInfo("show", "error", "Invalid email address. Please try again.");
        return false;
    } else generalInfo("hide");
    button.addClass("loading");
    var email = emailInput.val();
    var postData = {
        "email": email
    };
    var postDataJSON = JSON.stringify(postData);
    $.ajax({
        type: "POST",
        url: "https://grgeuubuuvpnizgtld3urpva2a0icfvv.lambda-url.us-east-1.on.aws/",
        contentType: "application/json",
        data: postDataJSON,
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log(textStatus + ", " + errorThrown);
            generalInfo("show", "error", "An error occurred. Please try again.");
            return false;
        },
        success: function(data, textStatus, xhr) {
            button.removeClass("loading");
            if (xhr.status == 204) generalInfo("show", "success", "Thank you for signing up!");
            else generalInfo("show", "error", "An error occurred. Please try again.");
        }
    });
});
/* update waitlist stats */ function updateWaitlistStats() {
    /*
	var currentReferredID = id;

	var	postData = {
		id: currentReferredID
	};
	*/ var socialIdToUse;
    if (!currentGetVariables().status && !localStorage.getItem("wl_social_id")) return;
    else {
        if (localStorage.getItem("wl_social_id")) socialIdToUse = localStorage.getItem("wl_social_id");
        if (currentGetVariables().status) socialIdToUse = currentGetVariables().status;
        var offsetTop = $("body").find('[id="waitlist_signup"]').offset().top - 60;
    /*$('html, body').animate({
			scrollTop: offsetTop
		}, 500);*/ }
    $.ajax({
        type: "GET",
        url: "https://api.kickofflabs.com/v1/171250/info?social_id=" + socialIdToUse,
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log(textStatus + ", " + errorThrown);
        },
        success: function(data) {
            if (data.id) {
                var id = data.id;
                var socialID = data.social_id;
                var rank = data.contest_score_rank;
                var invitedAmount = data.contest_score;
                $("body").find(".waitlist_signup").addClass("joined_waitlist");
                $("body").find('[data-fill="waitlist_referrer_url"].url').text("https://lmwr.com/?ref=" + socialID);
                $("body").find('[data-fill="waitlist_referrer_url"]:not(.url)').attr("data-copy", "https://lmwr.com/?ref=" + socialID);
                $("body").find("[data-meta-link]").attr("data-meta-link", "https://lmwr.com/?ref=" + socialID);
                $("body").find("[data-meta-url]").attr("data-meta-url", "https://lmwr.com/?ref=" + socialID);
                localStorage.setItem("wl_joined_status", 1);
                localStorage.setItem("wl_id", id);
                localStorage.setItem("wl_email", socialIdToUse);
                localStorage.setItem("wl_invite_score", invitedAmount);
                localStorage.setItem("wl_social_id", socialID);
                localStorage.setItem("wl_waitlist_position", rank);
                $("body").find(".waitlist_signup").addClass("joined_waitlist");
                $("body").find('[data-fill="waitlist_rank"]').text(rank);
                $("body").find('[data-fill="waitlist_invite_score"]').text(invitedAmount);
                $("body").find('[data-fill="your_id"]').html('Leaderboard <span class="your_id">Your ID: ' + socialID + "</span>");
                $("body").find('[data-fill="refresh_score"]').attr("href", "index.html?status=" + socialID);
                $("body").find('[data-fill="twitter_share"]').attr("href", "https://twitter.com/intent/tweet?text=LimeWire+Token%3A+Public+Sale.+Join+the+waitlist+%26+win+up+to+100%2C000+LMWR+%40limewire+https%3A%2F%2Flmwr.com%2F%3Fref%3D" + socialID);
                //$('body').find('[data-fill="status_url"]').attr('href', 'https://lmwr.com/status/' + id);
                //window.history.pushState('', 'LimeWire Waitlist', 'https://lmwr.com/status/' + id);
                setTimeout(function() {
                    (function() {
                        socializer(".socializer");
                    })();
                }, 1000);
            } else {
                localStorage.clear();
                $("body").find(".waitlist_signup").removeClass("joined_waitlist");
                generalInfo("show", "error", "An error occured. Please try again.");
                return false;
            }
        }
    });
}
/* update leaderboard */ function updateLeaderboard() {
    $.ajax({
        type: "GET",
        url: "https://api.kickofflabs.com/v1/171250/leaderboard?limit=6&lead_description=social_id",
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log(textStatus + ", " + errorThrown);
        },
        success: function(data) {
            if (data.leads) {
                $("body").find('.leaderboard [data-id="1"]').find("span.name").text(data.leads[0].social_id);
                $("body").find('.leaderboard [data-id="2"]').find("span.name").text(data.leads[1].social_id);
                $("body").find('.leaderboard [data-id="3"]').find("span.name").text(data.leads[2].social_id);
                $("body").find('.leaderboard [data-id="4"]').find("span.name").text(data.leads[3].social_id);
                $("body").find('.leaderboard [data-id="5"]').find("span.name").text(data.leads[4].social_id);
                $("body").find('.leaderboard [data-id="6"]').find("span.name").text(data.leads[5].social_id);
            }
        }
    });
}
$("body").on("click", '[data-action="refresh_leaderboard"]', function() {
    $("body").find(".leaderboard").find("span.name").text("Loading ...");
    updateLeaderboard();
});
var currentPage = $("body").find('[name="current_page"]').val();
$(document).ready(function() {
    updateLmwrPrice();
    updateLmwrPriceChange();
    if ($("body").find('[name="is_pools_page"]').val() == "true") {
        updatePoolStats();
        document.addEventListener("tf-loaded", function(e) {
        //console.log('TF has loaded!');
        });
    }
});
/* INIT */ function init() {
    switch(currentPage){
        case "step_2_signup":
            if (localStorage.getItem("flow_sumsub_process_started") == "true") $("body").find('[data-action="init_sumsub"]').text("Continue Verification");
            if (localStorage.getItem("flow_kyc_pending") == 1 && localStorage.getItem("flow_kyc_completed") != 1) $("body").find('[data-action="init_sumsub"]').click();
            if (localStorage.getItem("flow_kyc_completed") == 1) {
                $("body").find('[data-action="init_sumsub"]').addClass("completed").text("Verification Successful");
                // redirect to checkout
                window.location.href = "/checkout";
            }
            break;
    }
}
/* TOKEN PURCHASE FLOW - LOGIN */ $("body").on("submit", 'form[name="login"]', function(e) {
    "use strict";
    e.preventDefault();
    var button = $(this).find('button[type="submit"]');
    var emailInput = $("body").find('[name="login[email]"]');
    var error = false;
    if (!emailInput.val() || !isValidEmailAddress(emailInput.val())) {
        error = true;
        emailInput.addClass("error");
    } else emailInput.removeClass("error");
    if (error === true) {
        generalInfo("show", "error", "Invalid email address. Please try again.");
        return false;
    } else generalInfo("hide");
    button.addClass("loading");
    var postData = {
        email: emailInput.val()
    };
    $.ajax({
        type: "POST",
        url: "https://tokensale-api.limewire.com/login",
        data: postData,
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log(textStatus + ", " + errorThrown);
        },
        success: function(data) {
            //data = $.parseJSON(data);
            button.removeClass("loading");
            console.log(data);
            if (data.id) {
                localStorage.setItem("flow_id", data.id);
                localStorage.setItem("flow_email", data.email);
                localStorage.setItem("flow_kyc_completed", data.kyc_completed);
                localStorage.setItem("flow_kyc_pending", data.kyc_pending);
                localStorage.setItem("flow_sumsub_token", data.sumsub_token);
                $("body").find(".login_container").addClass("finished");
                $("body").find(".kyc_container").removeClass("locked");
                init();
                flowUpdateStatusBar();
            } else {
                localStorage.clear();
                generalInfo("show", "error", "An error occured. Please try again.");
                return false;
            }
        }
    });
});
function flowAutoLogin() {
    if (!isValidEmailAddress(localStorage.getItem("flow_email"))) {
        $("body").find(".flow").removeClass("is_loading");
        if (currentPage == "step_3_checkout") // redirect to first page (select)
        window.location.href = "/select";
        return false;
    }
    var postData = {
        email: localStorage.getItem("flow_email")
    };
    $.ajax({
        type: "POST",
        url: "https://tokensale-api.limewire.com/login",
        data: postData,
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log(textStatus + ", " + errorThrown);
        },
        success: function(data) {
            console.log(data);
            if (data.id) {
                localStorage.setItem("flow_id", data.id);
                localStorage.setItem("flow_email", data.email);
                localStorage.setItem("flow_kyc_completed", data.kyc_completed);
                localStorage.setItem("flow_kyc_pending", data.kyc_pending);
                localStorage.setItem("flow_sumsub_token", data.sumsub_token);
                $("body").find(".login_container").addClass("finished");
                $("body").find(".kyc_container").removeClass("locked");
                init();
                flowUpdateStatusBar();
            } else {
                console.log("flowAutoLogin() failed");
                return false;
            }
            $("body").find(".flow").removeClass("is_loading");
        }
    });
}
/* Update KYC Status and Email Address in Bar */ function flowUpdateStatusBar() {
    if (isValidEmailAddress(localStorage.getItem("flow_email"))) {
        $("body").find(".flow_status").hide();
        $("body").find(".flow_status.logged_in").show();
        $("body").find(".flow_status .email").text(localStorage.getItem("flow_email"));
        if (localStorage.getItem("flow_kyc_pending") == 1) {
            $("body").find(".flow_status .kyc_status").attr("class", "kyc_status pending");
            $("body").find(".flow_status .kyc_status").html('<a class="no_style" href="flow_step_2_signup.html?review_kyc=true">KYC Pending</a>');
        }
        if (localStorage.getItem("flow_kyc_completed") == 1) {
            $("body").find(".flow_status .kyc_status").attr("class", "kyc_status complete");
            $("body").find(".flow_status .kyc_status").text("KYC Completed");
        }
    }
}
/* SIGN OUT */ $("body").on("click", '[data-action="sign_out"]', function() {
    localStorage.removeItem("flow_id");
    localStorage.removeItem("flow_email");
    localStorage.removeItem("flow_kyc_completed");
    localStorage.removeItem("flow_kyc_pending");
    localStorage.removeItem("flow_sumsub_token");
    localStorage.removeItem("flow_sumsub_process_started");
    localStorage.removeItem("flow_sumsub_process_completed");
    window.location.href = "/verify";
});
/** SUMSUB FUNCTIONS
 * @param accessToken - access token that you generated on the backend in Step 2
 * @param applicantEmail - applicant email (not required)
 * @param applicantPhone - applicant phone, if available (not required)
 * @param customI18nMessages - customized locale messages for current session (not required)
 */ function launchWebSdk(accessToken, applicantEmail, applicantPhone, customI18nMessages) {
    let snsWebSdkInstance = snsWebSdk.init(accessToken, // token update callback, must return Promise
    // Access token expired
    // get a new one and pass it to the callback to re-initiate the WebSDK
    ()=>this.getNewAccessToken()).withConf({
        lang: "en",
        email: applicantEmail,
        phone: applicantPhone,
        i18n: customI18nMessages,
        uiConf: {
            customCss: "https://url.com/styles.css"
        }
    }).withOptions({
        addViewportTag: false,
        adaptIframeHeight: true
    })// see below what kind of messages WebSDK generates
    .on("idCheck.stepCompleted", (payload)=>{
        localStorage.setItem("flow_sumsub_process_started", true);
        console.log("stepCompleted", payload);
    }).on("idCheck.actionCompleted", (payload)=>{
        console.log("actionCompleted", payload);
    }).on("idCheck.moduleResultPresented", (payload)=>{
        console.log("moduleResultPresented", payload);
    }).on("idCheck.applicantStatus", (payload)=>{
        localStorage.setItem("flow_sumsub_process_completed", true);
        console.log("applicantStatus", payload);
        if (payload.reviewStatus == "pending" || payload.reviewStatus == "completed") {
            //if (payload.reviewResult.reviewAnswer == 'GREEN') {
            // show "Continue" button
            $("body").find("a.checkout").show();
            // if the page does not have review_kyc GET variable, redirect to checkout
            if (currentGetVariables().review_kyc != "true") setTimeout(function() {
                $("body").find("a.checkout").addClass("loading");
                setTimeout(function() {
                    // redirect to checkout
                    window.location.href = "/checkout";
                }, 3000);
            }, 0);
        }
    }).on("idCheck.onError", (error)=>{
        console.log("onError", error);
    }).build();
    // you are ready to go:
    // just launch the WebSDK by providing the container element for it
    snsWebSdkInstance.launch("#sumsub-websdk-container");
}
function getNewAccessToken() {
    return Promise.resolve(newAccessToken); // get a new token from your backend
}
// init sumsub
$("body").on("click", '[data-action="init_sumsub"]', function() {
    var button = $(this);
    button.addClass("loading");
    launchWebSdk(localStorage.getItem("flow_sumsub_token"), localStorage.getItem("flow_email"));
    button.hide();
});
/* UPDATE PERCENTAGE SOLD LOADING BAR */ function updatePercentageSold() {
    $.ajax({
        type: "GET",
        url: "https://ts-sale-status.lmwr.com/status_new",
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log(textStatus + ", " + errorThrown);
        },
        success: function(data) {
            if (data.percentage_sold) var totalPercentageSold = data.percentage_sold;
            else return false;
        }
    });
}
/* INDEX - INVESTORS SLIDER */ const lerp = (current, target, factor)=>current * (1 - factor) + target * factor;
class LoopingText {
    constructor(el){
        this.el = el;
        this.lerp = {
            current: 0,
            target: 0
        };
        this.interpolationFactor = 0.1;
        this.speed = 0.001;
        this.direction = -1; // -1 (to-left), 1 (to-right)
        // Init
        this.el.style.cssText = `position: relative; display: inline-flex; white-space: nowrap;`;
        this.el.children[1].style.cssText = `position: absolute; left: ${100 * -this.direction}%;`;
        this.events();
        this.render();
    }
    events() {
        window.addEventListener("scroll", ()=>this.lerp.target += this.speed * 5);
    }
    animate() {
        this.lerp.target += this.speed;
        this.lerp.current = lerp(this.lerp.current, this.lerp.target, this.interpolationFactor);
        if (this.lerp.target > 100) {
            this.lerp.current -= this.lerp.target;
            this.lerp.target = 0;
        }
        const x3 = this.lerp.current * this.direction;
        this.el.style.transform = `translateX(${x3}%)`;
    }
    render() {
        this.animate();
        window.requestAnimationFrame(()=>this.render());
    }
}
if ($("body").hasClass("index")) document.querySelectorAll(".investors").forEach((el)=>new LoopingText(el));
/* index coin animation */ function startCoinAnimation() {
    setInterval(function() {
        var currentImage = $("body").find("#coin_animation_sequence").find('img[data-visibility="visible"]');
        var nextImage = $(currentImage).next();
        if (currentImage.hasClass("last")) nextImage = $("body").find("#coin_animation_sequence .first");
        currentImage.css("opacity", 0).attr("data-visibility", "hidden");
        nextImage.css("opacity", 1).attr("data-visibility", "visible");
    }, 50);
}
$("document").ready(()=>{
    const lastImgIdx = 149;
    let loadedCount = 0;
    const imgLoaded = ()=>{
        loadedCount++;
        // console.log(`loaded ${loadedCount}/${149}`);
        if (loadedCount === lastImgIdx) startCoinAnimation();
    };
    const container = document.querySelector("#coin_animation_sequence");
    if (!!container) for(let i = 1; i <= lastImgIdx; i++){
        const img = new Image();
        img.onload = imgLoaded;
        img.src = `img/coin_animation/animation_1_149_pcs_896\u{200A}\xd7\u{200A}896/coin_animation_${i.toString().padStart(4, "0")}.png`;
        img.style.opacity = 0;
        img.draggable = false;
        img.setAttribute("data-visibility", "hidden");
        if (i === lastImgIdx) img.className = "last";
        container.appendChild(img);
    }
});
/* UPDATE LMWR PRICE */ function updateLmwrPrice() {
    $.ajax({
        type: "GET",
        url: "https://api.limewire.com/payments/exchangerates",
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log(textStatus + ", " + errorThrown);
        },
        success: function(data) {
            //data = '{"USDEUR":1.0809906545773624,"LMWRUSDC":1.454479964963018031,"BTCUSDC":0.000019265852106389,"USDCBTC":51905.308650655636,"USDCBNB":352.05990643418215,"BNBUSDC":0.002840425682459672,"USDCETH":2963.4147840586984,"USDCALGO":0.19275512920591295,"LMWRETH":4310.2274312885852930993555215908504,"USDGBP":1.2623841213103983,"ETHUSDC":0.000337448542600033,"LMWRBNB":512.06408037527265978973292518834665,"USDUSDC":0.999973384177596157,"EURUSDC":0.925077377649460330,"GBPUSDC":0.792151915664120899,"USDCLMWR":0.6875309554541896,"ALGOUSDC":5.187929390619422401}';
            //data = $.parseJSON(data);
            var lmwrUsdt;
            if (data.LMWRUSDC) {
                lmwrUsdt = (1 / data.LMWRUSDC).toFixed(4);
                $("body").find(".current_price").html("$" + lmwrUsdt);
            } else return false;
        }
    });
}
/* UPDATE LMWR PRICE CHANGE */ function updateLmwrPriceChange() {
    $.ajax({
        type: "GET",
        url: "https://api.limewire.com/payments/price-changes",
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log(textStatus + ", " + errorThrown);
        },
        success: function(data) {
            //data = '{"priceChanges":[{"currency":"ALGO","percentageChange24h":-3.34839228},{"currency":"ETH","percentageChange24h":1.47128451},{"currency":"BTC","percentageChange24h":0.20709748},{"currency":"LMWR","percentageChange24h":-1.92121724},{"currency":"BNB","percentageChange24h":0.32643431}]}';
            //data = $.parseJSON(data);
            //console.log(data);
            var priceChange;
            if (data.priceChanges[3].currency == "LMWR" && data.priceChanges[3].percentageChange24h) {
                priceChange = data.priceChanges[3].percentageChange24h.toFixed(2);
                $("body").find(".current_price_change").html(priceChange + "%");
                if (priceChange < 0) $("body").find(".current_price_change").attr("class", "current_price_change negative");
                else $("body").find(".current_price_change").attr("class", "current_price_change positive");
            } else return false;
        }
    });
}
/* OPEN STAKING POOL */ $("body").on("click", "[data-open-pool]", function() {
    var button = $(this);
    button.text("Loading ...");
    TF.init({
        id: "pool_container",
        farmType: "staking",
        nonce: $(this).attr("data-open-pool"),
        token: "LMWR",
        darkMode: true
    });
    document.addEventListener("tf-farm-loaded", function(e) {
        TF.show();
        button.text("VIEW POOL");
    });
});
/* UPDATE APY & TVL */ function updatePoolStats() {
    $.ajax({
        type: "GET",
        url: "https://tf-api.tokensfarm.com/farm/config?symbol=lmwr&type=staking&nonce=1",
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log(textStatus + ", " + errorThrown);
        },
        success: function(data) {
            var stakingPoolDOM = $("body").find(".pools .pool:nth-child(1)");
            if ($.isNumeric(data.apy)) stakingPoolDOM.find(".apy .info").text(addCommas(data.apy.toFixed(0)) + "%");
            else stakingPoolDOM.find(".apy .info").text("View Pool to see APY");
            if ($.isNumeric(data.farmLiquidity)) stakingPoolDOM.find(".tvl .info").text("USD $" + addCommas(data.farmLiquidity.toFixed(0)));
            else stakingPoolDOM.find(".tvl .info").text("View Pool to see TVL");
        }
    });
    $.ajax({
        type: "GET",
        url: "https://tf-api.tokensfarm.com/farm/config?symbol=lmwr&type=staking&nonce=2",
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log(textStatus + ", " + errorThrown);
        },
        success: function(data) {
            var stakingPoolDOM = $("body").find(".pools .pool:nth-child(2)");
            if ($.isNumeric(data.apy)) stakingPoolDOM.find(".apy .info").text(addCommas(data.apy.toFixed(0)) + "%");
            else stakingPoolDOM.find(".apy .info").text("View Pool to see APY");
            if ($.isNumeric(data.farmLiquidity)) stakingPoolDOM.find(".tvl .info").text("USD $" + addCommas(data.farmLiquidity.toFixed(0)));
            else stakingPoolDOM.find(".tvl .info").text("View Pool to see TVL");
        }
    });
    $.ajax({
        type: "GET",
        url: "https://tf-api.tokensfarm.com/farm/config?symbol=lmwr&type=staking&nonce=3",
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log(textStatus + ", " + errorThrown);
        },
        success: function(data) {
            var stakingPoolDOM = $("body").find(".pools .pool:nth-child(3)");
            if ($.isNumeric(data.apy)) stakingPoolDOM.find(".apy .info").text(addCommas(data.apy.toFixed(0)) + "%");
            else stakingPoolDOM.find(".apy .info").text("View Pool to see APY");
            if ($.isNumeric(data.farmLiquidity)) stakingPoolDOM.find(".tvl .info").text("USD $" + addCommas(data.farmLiquidity.toFixed(0)));
            else stakingPoolDOM.find(".tvl .info").text("View Pool to see TVL");
        }
    });
    $.ajax({
        type: "GET",
        url: "https://tf-api.tokensfarm.com/farm/config?symbol=lmwr&type=staking&nonce=4",
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log(textStatus + ", " + errorThrown);
        },
        success: function(data) {
            var stakingPoolDOM = $("body").find(".pools .pool:nth-child(4)");
            if ($.isNumeric(data.apy)) stakingPoolDOM.find(".apy .info").text(addCommas(data.apy.toFixed(0)) + "%");
            else stakingPoolDOM.find(".apy .info").text("View Pool to see APY");
            if ($.isNumeric(data.farmLiquidity)) stakingPoolDOM.find(".tvl .info").text("USD $" + addCommas(data.farmLiquidity.toFixed(0)));
            else stakingPoolDOM.find(".tvl .info").text("View Pool to see TVL");
        }
    });
}
/* IF SAFARI, SHOW STILL ANIMATION IMAGE */ var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if (isSafari) {
    $("body").addClass("is_safari");
    $("body").find(".coin_animation").hide();
    $("body").find(".coin_animation_still").show();
}
/* SET CURRENT YEAR IN FOOTER COPYRIGHT */ $(".js-current-year").text(new Date().getFullYear());

//# sourceMappingURL=index.9ab99047.js.map
